module.exports = __webpack_public_path__ + "static/img/bg1.a334189e.png";